export const APP_CONFIG = {
appName: 'Benefits | University of Houston',
frontend: 'https://uhsfinancialwellness.com',
apiHash: 'https://uhsfinancialwellness.com/api/1.0',
api: '/api/2.0',
trustModel: false,
authHeaders: {
xServiceProvider: 'uh-prod-frontend',
'tenant-id': '0c313e34-1864-41ce-a129-38aef1ce975d',
'consumer-id': '04ed6a90-7b54-461a-bd1a-f84cfb84deaa',
},
provider: 'uh-prod-frontend',
colors: {
primary: '#c8102e',
secondary: '#111111',
},
 imagery: {
        logo: 'https://storage.googleapis.com/archipelago-assets/uh/UoH%20Logo.svg',
        logos: [
            {
                zone: 1,
                url: 'https://storage.googleapis.com/archipelago-assets/uh/UoH%20Logo.svg',
                alt: 'University of Houston Main Campus'
            },
            {
                zone: 2,
                url: 'https://storage.googleapis.com/archipelago-assets/uh/UoH%20Clear%20Lake%20Logo.png',
                alt: 'University of Houston Clear Lake'
            },
            {
                zone: 3,
                url: 'https://storage.googleapis.com/archipelago-assets/uh/UoH%20Downtown%20Logo.png',
                alt: 'University of Houston Downtown'
            },
        ]
    },
multilingual: true,
demoMode: false,
contactEnabled: true,
chatEnabled: false,
isDarkModeEnabled: false,
gtm: 'GTM-MCXQ5NR5',
copyright: '&copy; ' + new Date().getFullYear() + ' Core. All Rights Reserved.' + ' Powered by Gallagher.',
navigation: {
navType: 'top',
collapsibleSidenav: false,
headerStyle: 'solid',
categoryNav: true
},
   enableSSR: false,
};
